module.exports = __webpack_public_path__ + "static/media/nose.ed376e19.jpg";